import type { CampaignPausedReason } from 'entities/campaign';
import type { Option } from 'shared/ui/Select';

export const getCampaignPausedReasonsOptions = (data: CampaignPausedReason[] | undefined): Option[] | null => {
  if (!data) {
    return null;
  }

  return data.map(({ id, title }) => ({
    id: id.toString(),
    text: title,
  }));
};
